    /* facets.js — complete */

    class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
        }, 500);

        this.facetForm = this.querySelector('form');
        if (this.facetForm) {
        this.facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
        this.facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));
        }

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

        this.loadTouts();

        // Optional: open sort drawer programmatically (if you use this trigger)
        const sortTrigger = document.getElementById('OpenSortDrawerButton');
        if (sortTrigger) {
        sortTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            const drawerDetails = document.querySelectorAll('.mobile-facets__disclosure')[1] || document.querySelector('.mobile-facets__disclosure');
            if (!drawerDetails) return;
            const summary = drawerDetails.querySelector('summary');
            if (!drawerDetails.open && summary) summary.click();

            // After the drawer toggles, ensure Sort section is open/focused
            requestAnimationFrame(() => {
            const productGrid = document.getElementById('product-grid');
            const sectionId = productGrid ? productGrid.dataset.id : null;
            const sortDetails = document.getElementById(`Details-Mobile-sort_by-${sectionId || ''}`) ||
                                document.querySelector('[id^="Details-Mobile-sort_by-"]');
            if (sortDetails) {
                sortDetails.setAttribute('open', '');
                sortDetails.classList.add('menu-opening');
                const closeBtn = sortDetails.querySelector('.mobile-facets__close-button');
                if (closeBtn) closeBtn.focus();
            }
            });
        });
        }
    }

    /*loadTouts() {
        if (!this.facetForm) return;
        const searchParams = this.createSearchParams(this.facetForm);
        const cont = document.getElementById('ProductGridContainer');
        if (!cont) return;
        if (searchParams === 'sort_by=manual' || searchParams.length === 0) {
        cont.classList.remove('filtered');
        } else {
        cont.classList.add('filtered');
        }
    }
    */
    /*
    loadTouts() {
        const cont = document.getElementById('ProductGridContainer');
        if (!cont) return;
        cont.classList.toggle('filtered', hasActiveFilters());
    }
    */
    /* ALWAYS SHOW IMAGE TOUTS */
    loadTouts() {
        const cont = document.getElementById('ProductGridContainer');
        if (!cont) return;
        cont.classList.remove('filtered'); // never hide touts
    }


    /* ---------- lifecycle / history ---------- */

    static setListeners() {
        const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((el) => {
        el.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;

        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');

        loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

        const cont = document.getElementById('ProductGridContainer');
        if (cont) {
            /*
            if (searchParams === 'sort_by=manual' || searchParams.length === 0) {
                cont.classList.remove('filtered');
            } else {
                cont.classList.add('filtered');
            }
            */
            //cont.classList.toggle('filtered', hasActiveFilters(searchParams));
            cont.classList.remove('filtered');
            const collectionEl = cont.querySelector('.collection');
            if (collectionEl) collectionEl.classList.add('loading');

        }

        if (countContainer) countContainer.classList.add('loading');
        if (countContainerDesktop) countContainerDesktop.classList.add('loading');

        sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
            ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
            : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
        .then((r) => r.text())
        .then((responseText) => {
            const html = responseText;
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
            FacetFiltersForm.renderFilters(html, event);
            FacetFiltersForm.renderProductGridContainer(html);
            FacetFiltersForm.renderProductCount(html);
            if (typeof initializeScrollAnimationTrigger === 'function') {
            try { initializeScrollAnimationTrigger(); } catch(e) {}
            }
            const productGrid = document.querySelector('#ProductGridContainer');
            if (productGrid && typeof productGrid.connectedCallback === 'function') {
            productGrid.connectedCallback();
            }
        });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }

    /* ---------- DOM swaps ---------- */

    static renderProductGridContainer(html) {
        const cont = document.getElementById('ProductGridContainer');
        if (!cont) return;
        cont.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer').innerHTML;

        cont.querySelectorAll('.scroll-trigger').forEach((el) => {
        el.classList.add('scroll-trigger--cancel');
        });

        // Notify listeners (hide-OOS, pills, etc.)
        dispatchFiltersUpdated();
        updateResultsCountUI();
        updateSortTriggerText(); // keep sort trigger label in sync
    }

    static renderProductCount(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const serverCount = doc.querySelector('.collection')?.getAttribute('data-count') || 0;
        updateResultsCountUI(serverCount);
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const fromFetch = parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );
        const fromDom = document.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );

        // Remove facets that are no longer returned from the server
        Array.from(fromDom).forEach((current) => {
        if (!Array.from(fromFetch).some(({ id }) => current.id === id)) current.remove();
        });

        const matchesId = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.id === jsFilter.id : false;
        };
        const facetsToRender = Array.from(fromFetch).filter((el) => !matchesId(el));
        const countsToRender = Array.from(fromFetch).find(matchesId);

        facetsToRender.forEach((elToRender, index) => {
        const current = document.getElementById(elToRender.id);
        if (current) {
            current.innerHTML = elToRender.innerHTML;
        } else {
            if (index > 0) {
            const { className: prevClass, id: prevId } = facetsToRender[index - 1];
            if (elToRender.className === prevClass) {
                document.getElementById(prevId).after(elToRender);
                return;
            }
            }
            if (elToRender.parentElement) {
            document.querySelector(`#${elToRender.parentElement.id} .js-filter`).before(elToRender);
            }
        }
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) {
        const closestJSFilterID = event?.target?.closest('.js-filter')?.id;
        if (closestJSFilterID) {
            FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
            FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

            const newFacetDetailsElement = document.getElementById(closestJSFilterID);
            const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
            const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
            if (newElementToActivate) newElementToActivate.focus();
        }
        }
    }

    static renderActiveFacets(html) {
        const selectors = ['.active-facets-mobile', '.active-facets-desktop'];

        selectors.forEach((selector) => {
        const source = html.querySelector(selector);
        if (!source) return;
        document.querySelectorAll(selector).forEach((dest) => {
            dest.innerHTML = source.innerHTML;
        });
        });

        FacetFiltersForm.toggleActiveFacets(false);

        // Decide using the *new URL* and the freshly-fetched server HTML
        const params = new URLSearchParams(location.search);
        const oosInUrl = params.get('filter.v.availability') === '1';

        // Did the server say there are any active pills at all?
        const srcMobile  = html.querySelector('.active-facets-mobile .active-facets__list');
        const srcDesktop = html.querySelector('.active-facets-desktop .active-facets__list');
        const serverHasAnyPills =
        (!!srcMobile  && srcMobile.querySelector('.active-facets__item')) ||
        (!!srcDesktop && srcDesktop.querySelector('.active-facets__item'));

        // If URL has no OOS and server shows no active pills, force-clear OOS UI/state.
        // Otherwise, let the normal pill sync run.
        if (!oosInUrl && !serverHasAnyPills) {
        clearOOS();
        } else {
        syncOOSPill();
        }

    }

    static renderAdditionalElements(html) {
        // copy innerHTML for each matched node
        const copyAll = (selector) => {
        const from = html.querySelectorAll(selector);
        const to = document.querySelectorAll(selector);
        to.forEach((el, i) => {
            if (from[i]) el.innerHTML = from[i].innerHTML;
        });
        };

        copyAll('.mobile-facets__open');
        copyAll('.mobile-facets__count');
        copyAll('.sorting');

        const mobileForm = document.getElementById('FacetFiltersFormMobile');
        if (mobileForm) {
        const drawer = mobileForm.closest('menu-drawer');
        if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
        }

        // If you render an element with this id for sort title content, sync it:
        const srcSort = html.getElementById('SortDrawerLabel');
        const dstSort = document.getElementById('SortDrawerLabel');
        if (srcSort && dstSort) dstSort.innerHTML = srcSort.innerHTML;

        // After any swaps, make sure the sort trigger shows the current selection
        updateSortTriggerText();
    }

    static renderCounts(source, target) {
        const targetSummary = target.querySelector('.facets__summary');
        const sourceSummary = source.querySelector('.facets__summary');
        if (sourceSummary && targetSummary) targetSummary.outerHTML = sourceSummary.outerHTML;

        const targetHeader = target.querySelector('.facets__header');
        const sourceHeader = source.querySelector('.facets__header');
        if (sourceHeader && targetHeader) targetHeader.outerHTML = sourceHeader.outerHTML;

        const targetWrap = target.querySelector('.facets-wrap');
        const sourceWrap = source.querySelector('.facets-wrap');
        if (sourceWrap && targetWrap) {
        const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
        if (isShowingMore) {
            sourceWrap.querySelectorAll('.facets__item.hidden').forEach((hiddenItem) =>
            hiddenItem.classList.replace('hidden', 'show-more-item')
            );
        }
        targetWrap.outerHTML = sourceWrap.outerHTML;
        }
    }

    static renderMobileCounts(source, target) {
        const targetList = target.querySelector('.mobile-facets__list');
        const sourceList = source.querySelector('.mobile-facets__list');
        if (sourceList && targetList) targetList.outerHTML = sourceList.outerHTML;
    }

    static updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        return [
        {
            section: document.getElementById('product-grid').dataset.id,
        },
        ];
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();

        const currentForm = event.target.closest('form');
        const currentId = currentForm ? currentForm.id : '';
        const isSortChange = event.target.name === 'sort_by';

        // Progressive enhancement cleanup
        document.querySelectorAll('.no-js-list').forEach((el) => el.remove());

        const serialize = (id) => {
        const form = document.getElementById(id);
        return form ? new URLSearchParams(new FormData(form)).toString() : '';
        };

        let searchParams = '';

        if (currentId === 'FacetFiltersFormMobile' && !isSortChange) {
        // Mobile: a filter checkbox/price change
        searchParams = serialize('FacetFiltersFormMobile');
        } else if (currentId === 'FacetSortDrawerForm' || isSortChange) {
        // Mobile: sorting – merge current filters + sort
        searchParams = [serialize('FacetFiltersFormMobile'), serialize('FacetSortDrawerForm')].filter(Boolean).join('&');
        } else {
        // Desktop (or fallback): merge desktop filter + desktop sort
        searchParams = [serialize('FacetFiltersForm'), serialize('FacetSortForm')].filter(Boolean).join('&');
        }

        this.onSubmitForm(searchParams, event);
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }
    }

    /* ---------- static props ---------- */
    FacetFiltersForm.filterData = [];
    FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
    FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

    /* ---------- custom elements (guarded) ---------- */
    if (!customElements.get('facet-filters-form')) customElements.define('facet-filters-form', FacetFiltersForm);

    /* Price range */
    class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach((el) => el.addEventListener('change', this.onRangeChange.bind(this)));
        this.setMinAndMaxValues();
    }
    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }
    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));
        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
    }
    if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

    /* facet-remove */
    class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        if (!facetLink) return;
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }
    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        if (form && typeof form.onActiveFilterClick === 'function') form.onActiveFilterClick(event);
    }
    }
    if (!customElements.get('facet-remove')) customElements.define('facet-remove', FacetRemove);

    /* ---------- global listeners ---------- */

    // Close sort drawer automatically after picking a sort
    document.addEventListener('change', (e) => {
    if (e.target.name === 'sort_by') {
        const wrapper = e.target.closest('.mobile-facets__wrapper');
        const summary = wrapper && wrapper.querySelector('summary');
        if (summary) summary.click();
        updateSortTriggerText();
    }
    });

    /* ---------- Helpers: results count & hide OOS ---------- */

    function clearOOS() {
    // Remove grid state
    const grid = document.getElementById('product-grid');
    if (grid) grid.classList.remove('hide-sold-out');

    // Uncheck any availability checkboxes (mobile & desktop)
    document.querySelectorAll('input[name="filter.v.availability"][value="1"]').forEach(cb => {
        cb.checked = false;
    });

    // Remove OOS pill(s)
    document.querySelectorAll('.active-facets__item--oos').forEach(el => el.remove());

    // If no other pills remain, remove the bar
    document.querySelectorAll('.active-facets__bar').forEach(bar => {
        if (!bar.querySelector('.active-facets__item')) bar.remove();
    });
    }


    function visibleProductCount() {
    const grid = document.getElementById('product-grid');
    if (!grid) return 0;

    const hide =
        document.querySelector('input[name="filter.v.availability"][value="1"]')?.checked ||
        new URLSearchParams(location.search).get('filter.v.availability') === '1' ||
        grid.classList.contains('hide-sold-out');

    const sel = hide
        ? 'li[data-product-handle][data-in-stock="true"]'
        : 'li[data-product-handle]';

    return grid.querySelectorAll(sel).length;
    }

    function buildRemoveOOSUrl() {
    const params = new URLSearchParams(location.search);
    params.delete('filter.v.availability');
    const qs = params.toString();
    return location.pathname + (qs ? `?${qs}` : '');
    }

    function buildClearAllUrlPreserveSort() {
    const params = new URLSearchParams(location.search);
    // remove all filter.* params (incl. availability & price)
    [...params.keys()].forEach((k) => {
        if (k.startsWith('filter.')) params.delete(k);
    });
    const qs = params.toString();
    return location.pathname + (qs ? `?${qs}` : '');
    }
    
    function findExistingOOSPill(container) {
        // Our client pill (has marker class)
        const marked = container.querySelector('.active-facets__item--oos');
        if (marked) return marked;

            // Server pill: match by the removal URL
            const target = new URL(buildRemoveOOSUrl(), location.origin);
            const items = container.querySelectorAll('.active-facets__item a[href]');
            for (const a of items) {
                try {
                    const u = new URL(a.getAttribute('href'), location.origin);
                    if (u.pathname === target.pathname && u.search === target.search) {
                        return a.closest('.active-facets__item');
                    }
                } catch (e) {}
            }
        return null;
    }


    function syncOOSPill() {
    // Prefer live UI (checkbox) while user is interacting; fall back to URL if needed.
    const cb = document.querySelector('input[type="checkbox"][name="filter.v.availability"][value="1"]');
    const params = new URLSearchParams(location.search);
    const urlOn = params.get('filter.v.availability') === '1';
    const isOn = cb ? cb.checked : urlOn;

    const containers = document.querySelectorAll('.active-facets-mobile, .active-facets-desktop');

    containers.forEach((container) => {
        let bar  = container.querySelector('.active-facets__bar');
        let list = container.querySelector('.active-facets__list');
        const existing = findExistingOOSPill(container);

        if (isOn && !existing) {
        if (!bar) {
            bar = document.createElement('div');
            bar.className = 'active-facets__bar';

            const label = document.createElement('span');
            label.className = 'active-facets__label';
            label.textContent = 'Applied filters:';

            list = document.createElement('ul');
            list.className = 'active-facets__list';
            list.setAttribute('role', 'list');

            const clearA = document.createElement('a');
            clearA.className = 'active-facets__clear';
            clearA.href = buildClearAllUrlPreserveSort();
            clearA.textContent = 'Clear all';

            const clearWrap = document.createElement('facet-remove');
            clearWrap.appendChild(clearA);

            bar.append(label, list, clearWrap);
            container.appendChild(bar);
        }

        const li = document.createElement('li');
        li.className = 'active-facets__item active-facets__item--oos';

        const a = document.createElement('a');
        a.className = 'active-facets__button';
        a.href = buildRemoveOOSUrl();
        a.setAttribute('role', 'button');
        a.setAttribute('aria-label', 'Remove Hide out of stock');

        const text = document.createElement('span');
        text.className = 'active-facets__pill-label';
        text.textContent = 'Hide out of stock';

        const x = document.createElement('span');
        x.className = 'active-facets__x';
        x.textContent = '×';

        a.append(text, x);

        const wrap = document.createElement('facet-remove');
        wrap.appendChild(a);

        li.appendChild(wrap);
        list.appendChild(li);
        }

        if (!isOn && existing) {
        const barEl = container.querySelector('.active-facets__bar');
        existing.remove();
        if (barEl && !container.querySelector('.active-facets__item')) {
            barEl.remove();
        }
        }
    });
    }

    function hasActiveFilters(qs) {
        const params = new URLSearchParams(qs || window.location.search.slice(1));
        for (const [k, v] of params) {
            if (!v) continue;
            if (k.startsWith('filter.')) return true; // includes availability, price, options, etc.
        }
        return false;
    }


    function updateResultsCountUI(serverCount) {
    const footerCountEl = document.querySelector('.mobile-facets__footer .results-count');
    if (!footerCountEl) return;
    const n = visibleProductCount() || Number(serverCount) || 0;
    footerCountEl.textContent = `(${n})`;
    }

    (function () {
    const AVAIL_SEL = 'input[type="checkbox"][name="filter.v.availability"][value="1"]';

    function applyHideSoldOut(root = document) {
    const grid = root.querySelector('#product-grid');
    if (!grid) return;

    const params = new URLSearchParams(location.search);
    const urlHas = params.has('filter.v.availability');
    const urlOn  = params.get('filter.v.availability') === '1';
    const cbOn   = !!root.querySelector('input[type="checkbox"][name="filter.v.availability"][value="1"]')?.checked;

    const hide = urlHas ? urlOn : cbOn;

    grid.classList.toggle('hide-sold-out', hide);
    updateResultsCountUI();

    // Make the pill reflect the same state immediately
    syncOOSPill();
    }

    document.addEventListener('DOMContentLoaded', () => applyHideSoldOut());

    document.addEventListener('change', (e) => {
        if (e.target.matches(AVAIL_SEL)) applyHideSoldOut();
    });

    document.addEventListener('facets:updated', () => applyHideSoldOut());
    document.addEventListener('filters:updated', () => applyHideSoldOut());

    document.addEventListener('click', (e) => {
        const a = e.target.closest('a.active-facets__clear, a.mobile-facets__clear');
        if (!a) return;
        // Don’t block the theme handler—just clean up UI immediately
        clearOOS();
    });


    // Observe container for replacements
    const container = document.getElementById('ProductGridContainer');
    if (container) {
        const mo = new MutationObserver(() => applyHideSoldOut());
        mo.observe(container, { childList: true, subtree: true });
    }
    })();

    /* ---------- Sort trigger label ---------- */

    function currentSortMeta() {
        // Prefer radio in Sort drawer; fallback to hidden mobile input
        const form = document.getElementById('FacetSortDrawerForm');
        const value =
            form?.querySelector('input[name="sort_by"]:checked')?.value ||
            document.querySelector('#FacetFiltersFormMobile input[name="sort_by"]')?.value ||
            'manual';

        // No Unicode arrows here; we emit a direction flag instead.
        const map = {
            'manual':             { label: 'Featured' },
            'best-selling':       { label: 'Best selling' },
            'relevance':          { label: 'Relevance' },
            'price-ascending':    { label: 'Price', dir: 'up' },
            'price-descending':   { label: 'Price', dir: 'down' },
            'title-ascending':    { label: 'A-Z', dir: 'up' },
            'title-descending':   { label: 'Z-A', dir: 'down' },
            'created-ascending':  { label: 'Date', dir: 'up' },
            'created-descending': { label: 'Date', dir: 'down' }
        };
        return map[value] || { label: 'Sort' };
    }


    function updateSortTriggerText() {
        const sortForm = document.getElementById('FacetSortDrawerForm');
        if (!sortForm) return;

        const disclosure = sortForm.closest('.mobile-facets__disclosure');
        const labelEl = disclosure?.querySelector('.mobile-facets__open-label');
        if (!labelEl) return;

        // Keep the chevron if present, but rebuild the rest to avoid duplicates
        const chevron = labelEl.querySelector('svg') || null;

        labelEl.innerHTML = ''; // nuke any prior text/spans to prevent double labels

        const main = document.createElement('span');
        main.className = 'button-label-main';
        main.textContent = 'Sort By:';

        const value = document.createElement('span');
        value.className = 'button-label-value';

        const meta = currentSortMeta();
        value.textContent = meta.label;
        if (meta.dir) value.setAttribute('data-dir', meta.dir);
        else value.removeAttribute('data-dir');

        labelEl.append(main, document.createTextNode(' '), value);
        if (chevron) labelEl.appendChild(chevron);
    }


    /* ---------- utilities ---------- */

    document.addEventListener('DOMContentLoaded', syncOOSPill);
    document.addEventListener('facets:updated', syncOOSPill);
    document.addEventListener('filters:updated', syncOOSPill);

    // When the OOS checkbox is toggled
    document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="filter.v.availability"]')) {
        syncOOSPill();
    }
    });

    function dispatchFiltersUpdated() {
    try {
        document.dispatchEvent(new CustomEvent('facets:updated', { detail: { source: 'renderProductGridContainer' } }));
        document.dispatchEvent(new CustomEvent('filters:updated', { detail: { source: 'renderProductGridContainer' } }));
    } catch (e) {}
    }

    /* Initialize history listeners */
    FacetFiltersForm.setListeners();
